/**
 * The fields the appointment page is asking the user to complete (see `missing-details.ts`). Empty everywhere else, so a
 * field only draws its red state for a key in this set when the page asked for it; the patient chart never provides one.
 */

import { createContext, useContext } from 'react';
import type { MissingKey } from '@/patients/lib/missing-details';

const EMPTY: ReadonlySet<MissingKey> = new Set();

export const MissingFieldsContext = createContext<ReadonlySet<MissingKey>>(EMPTY);

export function useMissingFields(): ReadonlySet<MissingKey> {
  return useContext(MissingFieldsContext);
}
